export default __webpack_public_path__ + "static/media/ordelivery_login.682532f5.png";